import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import addIcon from "../../assets/icons/addItemIcon.svg";

interface DropdownItem {
  label: string;
  onClick: () => void;
}

interface SubHeaderProps {
  title: string;
  dropdownLabel?: string;
  menuItems?: DropdownItem[];
  createHandler?: boolean;
}

const SubHeader: React.FC<SubHeaderProps> = ({
  title,
  dropdownLabel = "Options",
  menuItems = [],
  createHandler,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div
      className="tab-page-layout-1-header"
      style={{
        flexDirection: "row",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div className="tab-page-layout-1-header-title-label">
        <p style={{ margin: 0 }}>{title}</p>
      </div>
      {createHandler && (
        <div className="tab-header-right-div ">
          <div
            className="add-btn-section header-icon"
            onClick={() => navigate('create')}
          >
            <img src={addIcon} className="icon-md" alt="Create" />
          </div>
        </div>
      )}
      {menuItems && menuItems.length > 0 && (
        <div style={{ paddingRight: "3rem" }}>
          <Button
            aria-controls="dropdown-menu"
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            {dropdownLabel}
          </Button>
          <Menu
            id="dropdown-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {menuItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  item.onClick();
                  handleMenuClose();
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </div>
      )}
    </div>
  );
};

export default SubHeader;
